<template>
  <div class="stripe-form-container">
    <!-- <div ref="card"></div> -->
    <b-row class="" v-if="card_error"><b-col>
        <!-- <div id="card-error" class="my-3">
          <p class="error_validation_message_p_dy">{{ card_error }}</p>
        </div> -->
        <b-alert variant="danger" :class="{
          'alert-danger-dy': client_name == 'DY',
        }" :show="card_error != null">{{ card_error }}
        </b-alert>
      </b-col></b-row>
    <b-row class="my-3">
      <b-col md="12">
        <b-form-group id="card-name-input-group" class="pb-0">
          <b-form-input class="form-control-auth" v-bind:class="{
            'form-control-auth-mid': client_name == 'MID',
            'form-control-auth-doom-yoga': client_name == 'DY',
          }" id="card_name_holder" v-model="card_name_holder" type="text" placeholder="Card Name Holder"
            required></b-form-input> </b-form-group></b-col></b-row>
    <!-- <label>Card Number</label> -->
    <div class="my-3">
      <div id="card-number"></div>
    </div>
    <b-row class="my-3" id="paymentCardExpiryCvcContainer">
      <b-col md="6" class="p-0 pr-1">
        <div id="card-expiry"></div>
      </b-col>
      <b-col md="6" class="p-0 pl-1">
        <div id="card-cvc"></div>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-center align-content-center mt-3">
      <button class="btn btn-login-dy" type="button" @click="purchase">
        Book Class
      </button>
    </div>
  </div>
</template>

<!-- <script src="https://js.stripe.com/v3/"></script> -->

<script>
let stripe = Stripe(
  "pk_test_51HlxJsJs0xpQGogFbpLLfJQqWLrWGUQvzskO03ksiMewViQ9S4Dbmn9ON1hMNuoNLxuwC4EFkxjFAqiCbrD0NAwy00xU3OnBeN"
),
  stripeElements = stripe.elements(),
  card = undefined;



import axios from "axios";
import $ from "jquery";

export default {
  name: "StripeForm",
  props: ["client_name"],
  data() {
    return {
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      card_name_holder: null,
      card_error: null,

      elementClasses: {
        base: "form-control form-control-auth form-control-auth-doom-yoga",
        focus: "focus",
        empty: "empty",
        invalid: "invalid",
      },
      style: {
        base: {
          color: "#fff",
          "::placeholder": {
            color: "#aaa",
          },
          fontWeight: "400",
          fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
          fontSize: "16px",
          lineHeight: "22px",
          // backgroundColor: "#393939",
          // color: "#fff",
          // "border-radius": "8px",
          // 'padding': "12px",

          // iconColor: "#c4f0ff",
          // fontWeight: "500",
          // fontFamily: "Futura LT",
          // fontSize: "16px",
          // fontSmoothing: "antialiased",
          // ":-webkit-autofill": {
          //   color: "#fce883",
          // },
        },

        invalid: {
          // All of the error styles go inside of here.
          // color: "#00ff00",
        },
      },
      stripe: Stripe(
        "pk_test_51HlxJsJs0xpQGogFbpLLfJQqWLrWGUQvzskO03ksiMewViQ9S4Dbmn9ON1hMNuoNLxuwC4EFkxjFAqiCbrD0NAwy00xU3OnBeN"
      ),
      stripeElements: null,
    };
  },
  mounted() {
    // console.log(options);
    // card = elements.create("card", options);
    // card.mount(this.$refs.card);
    this.stripe = Stripe(
      "pk_test_51HlxJsJs0xpQGogFbpLLfJQqWLrWGUQvzskO03ksiMewViQ9S4Dbmn9ON1hMNuoNLxuwC4EFkxjFAqiCbrD0NAwy00xU3OnBeN",
    )


    this.cardNumber = stripeElements.create("cardNumber", {
      classes: elementClasses,
      style: style,
      placeholder: "Card number",
    });
    this.cardNumber.mount("#card-number");
    // options.placeholder = "MM / YY";
    this.cardExpiry = stripeElements.create("cardExpiry", {
      classes: elementClasses,
      style: style,
    });
    this.cardExpiry.mount("#card-expiry");
    // options.placeholder = "CVC";
    this.cardCvc = stripeElements.create("cardCvc", {
      classes: elementClasses,
      style: style,
    });
    this.cardCvc.mount("#card-cvc");
  },
  methods: {
    purchase: function () {
      let temp = this;
      stripe.createToken(this.cardNumber).then(function (result) {
        // Access the token with result.token
        console.log(result);
        if (result.error != null) {
          // handle error here
          console.log(result.error);
          temp.card_error = result.error.message;
          return;
        } else {
          temp.card_error = null;
          temp.token = result.token.id;
          temp.submitPaymentForm();
        }
      });
      //  const { token, error } = await stripe.createToken(this.cardNumber);
      // if (error) {
      //   // handle error here
      //   document.getElementById('card-error').innerHTML = error.message;
      //   return;
      // }
      // console.log(token);
    },
    submitPaymentForm() {
      let event_date = window.sessionStorage.getItem("selected_date"),
        event_time = window.sessionStorage.getItem("selected_slot"),
        event_id = window.sessionStorage.getItem("selected_class"),
        is_private_class = window.sessionStorage.getItem("is_private_class"),
        user = JSON.parse(window.localStorage.getItem("user")),
        user_id = user != null ? user.id : null;

      console.log("in submit payment form ", this.client_name);
      console.log(this.token);
      console.log(window.localStorage);
      console.log(window.sessionStorage);
      if (user == null) {
        console.log("guest ");
        let first_name = window.sessionStorage.getItem("first_name"),
          last_name = window.sessionStorage.getItem("last_name"),
          mobile_number = window.sessionStorage.getItem("mobile_number"),
          email = window.sessionStorage.getItem("email"),
          level = window.sessionStorage.getItem("level"),
          contact_through = window.sessionStorage.getItem("contact_through"),
          get_updates = window.sessionStorage.getItem("get_updates"),
          agree_terms = window.sessionStorage.getItem("agree_terms");
        console.log(
          event_date,
          event_time,
          event_id,
          is_private_class,
          this.card_name_holder
        );
        console.log(
          first_name,
          last_name,
          mobile_number,
          email,
          level,
          contact_through,
          get_updates,
          agree_terms
        );
      } else {
        console.log(
          event_date,
          event_time,
          event_id,
          is_private_class,
          this.card_name_holder,
          user_id
        );
      }

      this.$fire({
        // title: "Title",
        text: "Class is booked successfully",
        type: "success",
        customClass: {
          container: "swal-container-dy",
        },
        timer: 3000,
      }).then((r) => {
        // console.log(r.value);
      });

      window.sessionStorage.clear();
      if (this.client_name == "DY") {
        this.$router.push({ name: "DoOmYogaCustomerEventsCalendar" });
      }
    },
  },
  beforeDestroy() {
    // card.destroy(this.$refs.card);
    this.cardNumber.destroy();
    this.cardExpiry.destroy();
    this.cardCvc.destroy();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Payment/StripeFormEvent.vue